/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectPermissionDetail } from './ProjectPermissionDetail';
import {
    ProjectPermissionDetailFromJSON,
    ProjectPermissionDetailFromJSONTyped,
    ProjectPermissionDetailToJSON,
    ProjectPermissionDetailToJSONTyped,
} from './ProjectPermissionDetail';

/**
 * 
 * @export
 * @interface ProjectPermissionInfo
 */
export interface ProjectPermissionInfo {
    /**
     * 
     * @type {Array<ProjectPermissionDetail>}
     * @memberof ProjectPermissionInfo
     */
    permissions?: Array<ProjectPermissionDetail>;
}

/**
 * Check if a given object implements the ProjectPermissionInfo interface.
 */
export function instanceOfProjectPermissionInfo(value: object): value is ProjectPermissionInfo {
    return true;
}

export function ProjectPermissionInfoFromJSON(json: any): ProjectPermissionInfo {
    return ProjectPermissionInfoFromJSONTyped(json, false);
}

export function ProjectPermissionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectPermissionInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'permissions': json['permissions'] == null ? undefined : ((json['permissions'] as Array<any>).map(ProjectPermissionDetailFromJSON)),
    };
}

export function ProjectPermissionInfoToJSON(json: any): ProjectPermissionInfo {
    return ProjectPermissionInfoToJSONTyped(json, false);
}

export function ProjectPermissionInfoToJSONTyped(value?: ProjectPermissionInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(ProjectPermissionDetailToJSON)),
    };
}

